// Event Configuration for LOUNGES 26 Lectures
// This configuration is used by AllLectures.jsx for lecture registration

export const lounges26LectureConfig = {
  // Event identification
  eventId: "cb7a916e-ed71-483a-8177-22532ab0b237",
  eventName: "LOUNGES 2027",
  eventType: "fair",

  // Event dates configuration
  dates: {
    lectureRegistrationStartDate: "2025-08-15",
    lectureRegistrationEndDate: "2025-11-30",
    lectureEditEndDate: "2025-11-30",
    lectureDocumentsEndDate: "2026-01-31",
    lectureLectureEndDate: "2026-02-28",
    lectureRecordingCorrectionEndDate: "2026-04-05",
  },

  // Available lecture types for this event
  availableLectureTypes: [
    "vip",
    "technical",
    "educational",
    "marketing"
  ],

  // Steps configuration - dynamic based on i18n
  stepsConfig: (t) => [
    {
      id: "information",
      title: t("Information"),
      expandable: false,
      expanded: false,
      active: true,
      complete: false,
      requiresCompletion: true,
      validationRules: {}
    },
    {
      id: "general_conditions",
      title: t("Lecture Conditions"),
      expandable: false,
      expanded: false,
      active: false,
      complete: false,
      requiresCompletion: true,
      validationRules: {
        required: ['generalConditions'],
        skipValidation: true
      }
    },
    {
      id: "lecture_type",
      title: t("Lecture Type"),
      expandable: false,
      expanded: false,
      active: false,
      complete: false,
      validationRules: {
        required: ['type']
      }
    },
    {
      id: "details",
      title: t("Lecture Details"),
      expandable: true,
      expanded: true,
      active: false,
      complete: false,
      substeps: [
        {
          id: "language",
          title: t("Language"),
          complete: false,
          active: false,
          validationRules: {
            required: ['language']
          }
        },
        {
          id: "title",
          title: t("Title"),
          complete: false,
          active: false,
          validationRules: {
            required: ['title'],
            minLength: { title: 10 }
          }
        },
        {
          id: "subjects",
          title: t("Subjects"),
          complete: false,
          active: false,
          validationRules: {
            required: ['subjects']
          }
        },
        {
          id: "description",
          title: t("Description"),
          complete: false,
          active: false,
          validationRules: {}
        },
        {
          id: "topics",
          title: t("Topics"),
          complete: false,
          active: false,
          validationRules: {
            required: ['topics'],
            custom: (data) => {
              const topics = data.topics || [];
              return topics.length >= 1 && topics.length <= 3;
            }
          }
        },
        {
          id: "speakers",
          title: t("Speakers"),
          complete: false,
          active: false,
          validationRules: {
            required: ['speakers'],
            custom: (data) => data.speakers?.length >= 1
          }
        },
        {
          id: "image",
          title: t("Image"),
          complete: false,
          active: false,
          validationRules: {}
        },
        {
          id: "handout",
          title: t("Handout"),
          complete: false,
          active: false,
          validationRules: {}
        },
        {
          id: "presentation",
          title: t("Presentation"),
          complete: false,
          active: false,
          validationRules: {}
        },
      ],
    },
    {
      id: "review",
      title: t("Review"),
      expandable: false,
      expanded: false,
      active: false,
      complete: false,
      isLast: true,
      neutralDisplay: true,
      validationRules: {}
    },
  ],

  // Step content - text strings for each step
  stepContent: {
    content: {
      tipsHeading: [
        { language: "de", text: "Tipps für eine gute Beschreibung:" },
        { language: "en", text: "Tips for a good description:" }
      ],
      tips: [
        { language: "de", text: "Welche Themen werden behandelt?" },
        { language: "en", text: "What topics will be covered?" }
      ],
      tips2: [
        { language: "de", text: "Was werden die Teilnehmer lernen?" },
        { language: "en", text: "What will participants learn?" }
      ],
      tips3: [
        { language: "de", text: "Wer ist die Zielgruppe?" },
        { language: "en", text: "Who is the target audience?" }
      ],
      tips4: [
        { language: "de", text: "Welche Vorkenntnisse oder Hintergrundwissen sind erforderlich?" },
        { language: "en", text: "Any prerequisites or background knowledge needed?" }
      ]
    }
  },

  // Information content for the information step (multilingual)
  informationContent: [
    {
      language: "de",
      content: `
    <h4>Vortragseinreichung für die LOUNGES 2027</h4>

    <p>Bevor Du mit der Einreichung beginnst, lese die nachfolgenden Informationen bitte sorgfältig durch.<br>
    <strong>Nur wenn die genannten Termine und Standards eingehalten werden, kann der Vortrag angenommen werden.</strong></p>

    <h5>Wichtige Termine</h5>
    <ul>
        <li><strong>Beginn der Einreichung:</strong> 15. August 2026</li>
        <li><strong>Einreichungsschluss:</strong> 30. November 2026</li>
        <li><strong>Bestätigungsfrist eingereichter/unvollständiger Vorträge:</strong> 30. November 2026</li>
        <li><strong>Keine Einreichungen mehr ab:</strong> 1. Dezember 2026</li>
    </ul>
      <br />
    <h4>Vortragsarten</h4>
    <p>Folgende Vortragskategorien stehen zur Auswahl.</p>

    <h6><strong>VIP-Vortrag</strong></h6>
    <ul>
        <li>Vortrag gemeinsam mit einem Behördenvertreter</li>
        <li>Oder Vortrag über Projekte, die gemeinsam mit dem Kunden umgesetzt werden/wurden und gemeinsam mit mindestens 2 Personen auch vorgetragen werden
        <ul><li>Kunde bedeutet hier: Arzneimittelhersteller</li></ul></li>
        <li>Vortrag wird auf der Internetseite sowie zusätzlich separat über LinkedIn und anderen Medien einzeln beworben</li>
        <li>Studiobühne oder ECV-Stage</li>
    </ul>

    <h6><strong>Fachvortrag *</strong></h6>
    <ul>
        <li>Expertenwissen, Forschungsergebnisse, Guidelines, Innovationen, Kundenprojekte</li>
        <li>Vortrag wird auf der Internetseite sowie über das Programm über LinkedIn und anderen Medien einzeln beworben</li>
        <li>Vortragsraum 1,2,3,6,7,8</li>
    </ul>

    <h6><strong>Schulungsvortrag *</strong></h6>
    <ul>
        <li>Vermittlung von Basiskenntnissen und Grundlagen</li>
        <li>Vortrag wird auf der Internetseite sowie über das Programm über LinkedIn und anderen Medien einzeln beworben</li>
        <li>Vortragsraum 4,5</li>
    </ul>

    <h6><strong>Marketing-Vortrag</strong></h6>
    <ul>
        <li>Firmenpräsentation, Produktvorstellung, Dienstleistungen, USPs, Kundenprojekte</li>
        <li>Vortrag wird auf der Internetseite sowie über das Programm beworben</li>
        <li>Vortragsraum 9</li>
    </ul>

    <p><em>* Die Art der Einreichung deiner Vorträge obliegt dir und deine Firma. Allerdings wird die finale Zuteilung durch den Veranstalter bestimmt. Fachvorträge mit Schulungscharakter werden in den Schulungsräumen platziert.</em></p>
      `
    },
    {
      language: "en",
      content: `
    <h4>Lecture Submission for LOUNGES 2027</h4>

    <p>Before you begin the submission, please read the following information carefully.<br>
    <strong>Only if the mentioned deadlines and standards are met, the lecture can be accepted.</strong></p>

    <h5>Important Dates</h5>
    <ul>
        <li><strong>Start of submission:</strong> August 15, 2025</li>
        <li><strong>Submission deadline:</strong> November 30, 2025</li>
        <li><strong>Confirmation deadline for submitted/incomplete lectures:</strong> November 30, 2025</li>
        <li><strong>No more submissions after:</strong> December 1, 2025</li>
    </ul>
    <br />
    <h4>Lecture Types</h4>
    <p>The following lecture categories are available.</p>

    <h6><strong>VIP Lecture</strong></h6>
    <ul>
        <li>Lecture together with a government representative</li>
        <li>Or lecture about projects that are/were implemented together with the customer and are also presented together with at least 2 people
        <ul><li>Customer means here: pharmaceutical manufacturer</li></ul></li>
        <li>Lecture will be advertised individually on the website as well as separately via LinkedIn and other media</li>
        <li>Studio stage or ECV stage</li>
    </ul>

    <h6><strong>Technical Lecture *</strong></h6>
    <ul>
        <li>Expert knowledge, research results, guidelines, innovations, customer projects</li>
        <li>Lecture will be advertised individually on the website as well as via the program on LinkedIn and other media</li>
        <li>Lecture room 1,2,3,6,7,8</li>
    </ul>

    <h6><strong>Educational Lecture *</strong></h6>
    <ul>
        <li>Teaching basic knowledge and fundamentals</li>
        <li>Lecture will be advertised individually on the website as well as via the program on LinkedIn and other media</li>
        <li>Lecture room 4,5</li>
    </ul>

    <h6><strong>Marketing Lecture</strong></h6>
    <ul>
        <li>Company presentation, product introduction, services, USPs, customer projects</li>
        <li>Lecture will be advertised on the website and via the program</li>
        <li>EXPO stage in the exhibition</li>
    </ul>

    <p><em>* The type of submission of your lectures is up to you and your company. However, the final allocation will be determined by the organizer. Technical lectures with educational character will be placed in the training rooms.</em></p>
      `
    }
  ],

  // General conditions that apply to all users regardless of lecture type
  generalConditions: [
    {
      id: "submission_deadlines",
      title: [
        { language: "de", text: "Einreichungsfristen" },
        { language: "en", text: "Submission Deadlines" }
      ],
      checkboxLabel: [
        { language: "de", text: "Ich habe die Einreichungsfristen gelesen und akzeptiere diese." },
        { language: "en", text: "I have read and accept the submission deadlines." }
      ],
      content: [
        { language: "de", text: "Vorträge können ab dem 15. August 2026 eingereicht und müssen vollständig bis 30. November 2026 bestätigt werden. Nach dem 1. Dezember 2026 können keine Vorträge mehr eingereicht werden. Unvollständige Vorträge nach dem 30. November 2026 werden nicht ins Programm aufgenommen." },
        { language: "en", text: "Lectures can be submitted from August 15, 2025 and must be completely confirmed by November 30, 2025. No lectures can be submitted after December 1, 2025. Incomplete lectures after November 30, 2025 will not be included in the program." }
      ],
      required: true
    },
    {
      id: "advertising_free_content",
      title: [
        { language: "de", text: "Werbefreiheit der Vorträge" },
        { language: "en", text: "Advertising-Free Content" }
      ],
      checkboxLabel: [
        { language: "de", text: "Ich habe verstanden, dass der Vortrag werbefrei sein muss und akzeptiere dies." },
        { language: "en", text: "I understand that the lecture must be advertising-free and accept this." }
      ],
      content: [
        { language: "de", text: "VIP-, Fach- und Schulungsvorträge sind werbefrei (keine Produktnamen, Datenblätter oder Firmeninformationen)." },
        { language: "en", text: "VIP, technical and educational lectures must be advertising-free (no product names, data sheets or company information)." }
      ],
      required: true
    },
    {
      id: "recording_policy",
      title: [
        { language: "de", text: "Aufzeichnungsrichtlinien" },
        { language: "en", text: "Recording Policy" }
      ],
      checkboxLabel: [
        { language: "de", text: "Ich bin über die Aufzeichnungsrichtlinien informiert und akzeptiere diese." },
        { language: "en", text: "I am aware of and accept the recording policy." }
      ],
      content: [
        { language: "de", text: "VIP-, Fach- und Schulungsvorträge werden per Audio und Video aufgezeichnet. Die Aufzeichnungsrechte gehören der Inspire GmbH. Aufzeichnungen werden Teilnehmern und Nicht-Teilnehmern auf der Online-Plattform angeboten. Eigene Vorträge stehen Admins und Referenten kostenfrei zur Verfügung (Download nicht möglich). Aufzeichnungen können bis 5. April 2027 korrigiert werden, danach werden sie automatisch freigegeben." },
        { language: "en", text: "VIP, technical and educational lectures will be recorded in audio and video. Recording rights belong to Inspire GmbH. Recordings will be offered to participants and non-participants on the online platform. Your own lectures are available to admins and speakers free of charge (download not possible). Recordings can be corrected until April 5, 2026, after which they will be automatically released." }
      ],
      required: true
    },
    {
      id: "speaker_expertise",
      title: [
        { language: "de", text: "Qualifikation der Referenten" },
        { language: "en", text: "Speaker Expertise" }
      ],
      checkboxLabel: [
        { language: "de", text: "Ich bestätige, dass die Referenten qualifiziert sind." },
        { language: "en", text: "I confirm that the speakers are qualified." }
      ],
      content: [
        { language: "de", text: "Referenten sind Experten ihres Themas und bieten qualitativ hochwertige, didaktisch wertvolle Vorträge und haben kein Problem damit vor der Kamera zu präsentieren, sofern der Vortrag aufgezeichnet wird." },
        { language: "en", text: "Speakers are experts in their field and provide high-quality, didactically valuable lectures and have no problem presenting in front of the camera when the lecture is being recorded." }
      ],
      required: true
    },
    {
      id: "program_scheduling",
      title: [
        { language: "de", text: "Programmplanung" },
        { language: "en", text: "Program Scheduling" }
      ],
      checkboxLabel: [
        { language: "de", text: "Ich bin mit der Programmgestaltung / Zeiteinteilung durch den Veranstalter einverstanden." },
        { language: "en", text: "I agree with the program design / scheduling by the organizer." }
      ],
      content: [
        { language: "de", text: "Die Programmzuordnung erfolgt durch den Veranstalter und wird dem Admin und Referent bis zum 31. Januar 2027 mitgeteilt." },
        { language: "en", text: "Program scheduling is done by the organizer and will be communicated to the admin and speaker by January 31, 2026." }
      ],
      required: true
    },
    {
      id: "file_upload_deadlines",
      title: [
        { language: "de", text: "Fristen für Datei-Uploads" },
        { language: "en", text: "File Upload Deadlines" }
      ],
      checkboxLabel: [
        { language: "de", text: "Ich akzeptiere die Upload-Fristen für Vortragsunterlagen." },
        { language: "en", text: "I accept the upload deadlines for lecture materials." }
      ],
      content: [
        { language: "de", text: `Die Vortragsunterlagen werden den Teilnehmern der Veranstaltung zur Verfügung gestellt. Diese müssen bis zum folgenden Zeitpunkt in das System hochgeladen werden: 31. Januar 2027. Wenn bis zu diesem Datum keine Unterlagen hochgeladen wurden, wird der Vortrag aus dem Programm genommen.
          Präsentationsfolien (ppt oder pptx) für VIP-Vorträge, Fachvorträge und Schulungsvorträge müssen bis 28. Februar 2027 im System hochgeladen werden. Präsentationsfolien werden zur Aufzeichnung der Vorträge genutzt und nicht weitergegeben bzw. veröffentlicht.` },
        { language: "en", text: `Lecture materials / handouts (PDF) will be made available to event participants. Lecture materials must be uploaded to the system by January 31, 2026. If no lecture materials have been uploaded by this deadline, the lecture will be removed from the program.
          Lecture slides (PPT or PPTX) for VIP lectures, technical lectures and educational lectures must be uploaded to the system by February 28, 2026. Lecture slides are used for recording lectures and will not be shared or published.` }
      ],
      required: true
    }
  ],

  // Event-specific conditions with multilingual content
  eventConditions: [
    {
      id: "data_protection",
      content: [
        { language: "de", text: "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zu." },
        { language: "en", text: "I agree to the processing of my data according to the privacy policy." }
      ],
      applicableToTypes: ["vip", "technical", "educational", "marketing", "promotion_technical", "promotion_marketing"],
      required: true
    },
    {
      id: "vip_special_terms",
      content: [
        { language: "de", text: "Ich bestätige, dass dieser VIP-Vortrag exklusiven Content bietet und mindestens 2 Referenten erfordert." },
        { language: "en", text: "I confirm that this VIP lecture offers exclusive content and requires at least 2 speakers." }
      ],
      applicableToTypes: ["vip"],
      required: true
    },
    {
      id: "promotion_disclaimer",
      content: [
        { language: "de", text: "Ich verstehe, dass Promotion-Vorträge marketingorientierten Inhalt enthalten können." },
        { language: "en", text: "I understand that promotion lectures may contain marketing-oriented content." }
      ],
      applicableToTypes: ["marketing", "promotion_technical", "promotion_marketing"],
      required: false
    },
    {
      id: "technical_prerequisites",
      content: [
        { language: "de", text: "Ich bestätige, dass die technischen Voraussetzungen für diesen Vortrag erfüllt sind." },
        { language: "en", text: "I confirm that the technical prerequisites for this lecture are met." }
      ],
      applicableToTypes: ["technical", "promotion_technical"],
      required: false
    }
  ],

  // Required fields for form submission
  requiredFields: [
    "companyLecturesId",
    "type",
    "generalConditions",
    "title",
    "speakers",
    "content",
    "image",
    "topics",
    "subjects"
  ],

  // Conditional validation rules based on lecture type
  conditionalRules: [
    {
      condition: "type === 'vip'",
      additionalRequired: [],
      customValidations: {
        "speakers.min": 2
      }
    },
    {
      condition: "type === 'technical'",
      additionalRequired: [],
      customValidations: {
        "speakers.min": 1
      }
    },
    {
      condition: "type === 'educational'",
      additionalRequired: [],
      customValidations: {
        "speakers.min": 1
      }
    },
    {
      condition: "type === 'marketing'",
      additionalRequired: [],
      customValidations: {
        "speakers.min": 1
      }
    },
    {
      condition: "type === 'promotion_technical'",
      additionalRequired: [],
      customValidations: {
        "speakers.min": 1
      }
    },
    {
      condition: "type === 'promotion_marketing'",
      additionalRequired: [],
      customValidations: {
        "speakers.min": 1
      }
    }
  ],

  // Validation settings
  customValidations: {
    "content.text.minLength": 500,
    "content.text.maxLength": 5000,
    "title.text.minLength": 10,
    "title.text.maxLength": 60,
    "speakers.min": 1,
    "subjects.min": 3,
    "subjects.max": 5,
    "topics.min": 1,
    "topics.max": 3
  },

  // Field messages for UI
  fieldMessages: {
    "maxParticipants": "Teilnehmerzahl",
    "duration": "Workshop-Dauer",
    "prerequisites": "Voraussetzungen",
    "meetingLink": "Meeting-Link",
    "recordingAllowed": "Aufzeichnung-Erlaubnis",
    "certification": "Zertifizierung"
  }
};

// Export configuration
export default lounges26LectureConfig;